'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientUsersList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region
    },
    listUsers: function () {
      var self = this
      //
      self.users = App.globalChannel.request('user:entities', {
        query: {
          client: options.client.get('_id')
        }
      })

      var bodyModel = new BodyModel({
        title: 'Users',
        buttons: [
          { label: 'add user', primary: true, slug: 'user', action: 'client-users:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(bodyModel)

    //  self.layout.on('childview:client-users:edit', _.bind(self.onEdit, self))
      self.listenTo(self.layout, 'client-users:add', self.onAdd, self)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.users)
      })

      // view events
      self.region.show(self.layout)
    },
    listRegion: function (nodes, columns) {
      var self = this
      //
      var columns = {
        '_bulk': {
          'options': {
            'delete': {'label': 'Delete', 'roles': ['super']}
          }
        },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'email': {'label': 'email', 'sortable': true, 'roles': []},
        'role': {'label': 'role', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        'createdAt': {'label': 'created at', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': [] }
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No users yet.',
        subTitle: 'create some users to get started'
      })

      //
      var layout = this.getListView(nodes, columns, emptyViewModel)
      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:manage', self.onManage)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    onBulk: function (args) {
      switch (args.bulk_action) {
        case 'delete':
          App.dialog.confirm({
            message: 'Are you sure you want to peform a bulk delete?',
            callback: function (confirmed) {
              if (confirmed) {
                args.collection.bulkDelete({})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onAdd: function (args) {
      var self = this
      App.globalChannel.trigger('client-users:new', {region: App.rootLayout.getRegion('dialogRegion'), client: self.options.client, collection: this.users})
    },
    onRender: function (args) {
      // App.globalChannel.trigger('client:show', {model: args.model})
    },
    onEdit: function (args) {
      App.globalChannel.trigger('client-users:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    getListView: function (collection, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.listView({
        collection: collection,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (model) {
      return new View.layout({model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientUsersList



// WEBPACK FOOTER //
// ./js/modules/client-users/list/index.js